export const brl = (n) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

export const normalizeHandle = (h) => {
  h = (h || "").trim().toLowerCase();
  if (h && !h.startsWith("@")) h = "@" + h;
  return h;
};
